import { useDeleteForecastMutation } from "@common/api/forecast"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute("/_layout/forecasts/delete/$forecastId")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "forecast:update", "/"),
  component: DeleteForecastDialog,
})

function DeleteForecastDialog(): React.ReactElement {
  const { forecastId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteForecastMutation()

  const close = () => navigate({ to: "/forecasts", search: true })

  return (
    <DeleteDialog
      noun="forecast"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { forecast_id: forecastId },
          {
            onSuccess: () => {
              showToast("Deleted", "Forecast deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
